export default "__VITE_ASSET__BSuR1GWk__"